import * as Yup from "yup";

export const timeSchema = Yup.object().shape({
    startTime: Yup.string()
      .matches(
        /^(0[0-9]|1[0-9]|2[0-3]):([0-5][0-9]):([0-5][0-9])$/,
        "Invalid time format"
      )
      .required("Start time is required"),
    endTime: Yup.string()
      .matches(
        /^(0[0-9]|1[0-9]|2[0-3]):([0-5][0-9]):([0-5][0-9])$/,
        "Invalid time format"
      )
      .required("End time is required"),
  });